import React, { Component } from "react"
import AnchorLink from "react-anchor-link-smooth-scroll"
import Scrollspy from "react-scrollspy"
import { Link } from "gatsby"
import styled from "styled-components"

import { Nav, Brand, StyledContainer, ActionsContainer } from "./style"
import SookindLogo from "../../../images/product/sookind_logo_dark_blue.svg"

export default class Navigation extends Component {
  state = {
    mobileMenuOpen: false,
    hasScrolled: false,
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  handleScroll = event => {
    const scrollTop = window.pageYOffset

    if (scrollTop > 32) {
      this.setState({ hasScrolled: true })
    } else {
      this.setState({ hasScrolled: false })
    }
  }

  toggleMobileMenu = () => {
    this.setState(prevState => ({ mobileMenuOpen: !prevState.mobileMenuOpen }))
  }

  closeMobileMenu = () => {
    if (this.state.mobileMenuOpen) {
      this.setState({ mobileMenuOpen: false })
    }
  }

  getNavAnchorLink = item => (
    <AnchorLink href={`#${item.toLowerCase()}`} onClick={this.closeMobileMenu}>
      {item}
    </AnchorLink>
  )

  render() {
    return (
      <Nav {...this.props} scrolled={this.state.hasScrolled}>
        <StyledContainer>
          <Brand>
            <Scrollspy offset={-64} item={["top"]} currentClassName="active">
              <Link to="/#top" onClick={this.closeMobileMenu}>
                <LogoAndNameGrid>
                  <img
                    src={SookindLogo}
                    alt="Sookind Logo"
                    style={{
                      width: "1.4em",
                      height: "1.4em",
                      alignSelf: "center",
                    }}
                  />
                  <div>
                    <p>SOOKIND</p>
                  </div>
                </LogoAndNameGrid>
              </Link>
            </Scrollspy>
          </Brand>
          <ActionsContainer>
            <Link to="/#get-started">
              <button>Stay in touch</button>
            </Link>
          </ActionsContainer>
        </StyledContainer>
      </Nav>
    )
  }
}

const LogoAndNameGrid = styled.div`
  display: grid;
  grid-template-columns: 0.35fr 1fr;
  margin: 0px auto;
  grid-column-gap: 0.3em;
  justify-items: center;
  height: 100%;
  color: ${props => props.theme.color.blue.dark};

  p {
    font-size: 26px;

    @media (max-width: ${props => props.theme.screen.sm}) {
      font-size: 22px;
    }
  }
`
